<!--template for company logo, name, and description used on Pass's share landing page-->
<template>
  <div>
    <!-- if user is invited -->
    <div class="request-pass-container" v-if="isUserInvited">
      <div class="request-pass-header text-center">
        <p>Pass Invitation to</p>
      </div>

      <div class="request-pass-title text-center">
        <!-- Pass Title -->
        <h3> {{ passName }} </h3>
        <!-- <img :src="companyLogo" alt="Company Logo" height="100px"> -->
        <p>by <span class="company-name">{{ companyName }}</span></p>
      </div>

      <p class="request-pass-intro-copy text-center">{{ passIntro }}</p>

      <div>
        <div class="company-col-container text-center" v-if="!isLoggedIn">
          <img :src="companyLogo" alt="Company Logo">
          <h2>{{ companyName }}</h2>
        </div>

        <p v-if="!isToVerifyIdentity && !isLoggedIn" class="copy-subheader">
          has invited you to access this pass.
        </p>

        <p v-if="isToVerifyIdentity && !isLoggedIn" class="copy-subheader">
          is requesting you to validate your identity and review agreements to get this pass.
        </p>
      </div>
    </div>
    <!-- end if user is invited -->

    <div class="request-pass-container" v-else>
      <div class="request-pass-header text-center">
        <p>Request a pass to</p>
      </div>

      <div class="request-pass-title text-center">
        <!-- Pass Title -->
        <h3> {{ passName }} </h3>
        <!-- <img :src="companyLogo" alt="Company Logo" height="100px"> -->
        <p>by <span class="company-name">{{ companyName }}</span></p>
      </div>

      <p class="request-pass-intro-copy text-center">{{ passIntro }}</p>
    </div>
  </div>
</template>

<script>
const placeholderImage = 'https://placehold.jp/ebf0f5/9db4cc/150x150.png?text=YP'

export default {
  props: {
    isToVerifyIdentity: {
      type: Boolean,
      default: false
    },
    isUserInvited: {
      type: Boolean,
      default: false
    },
    isRequestAccepted: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    requestAccess: {
      type: Boolean,
      default: false
    },
    isRequestAccessAllowed: {
      type: Boolean,
      default: false
    },
    companyName:  {
      type: String,
      default: 'YeyPass'
    },
    companyLogo: {
      type: String,
      default: placeholderImage
    },
    passIntro: {
      type: String,
      default: ''
    },
    passName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
p {
  font-weight: 400;
}

.request-pass-container {
  border: solid 1px #E5E9EB
}

.request-pass-header {
  padding-top: 15px;
  padding-bottom: 0px;
}

.request-pass-title {
  background-color: #F2F9FF;
  padding-top: 20px;
  padding-bottom: 5px;
}

.pass-intro-header {
  max-height: 100px;
}

.pass-intro-header img {
  max-height: 100px;
}

.request-pass-intro-copy {
  width: 85%;
  margin: 0 auto;
  white-space: pre-line;
  padding-top: 25px;
  padding-bottom: 25px;
}

.company-name {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/pass_share/LandingHeader.vue